import { createReducer } from '@reduxjs/toolkit';
import { omit } from 'lodash';
import t from '@/store/types';

const initialState: {
  data: Record<string, any>;
  byOrganizationId: Record<string, any>;
} = {
  data: {},
  byOrganizationId: {},
};

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(t.ORGANIZATIONS_LIST_SET, (state, action: any) => {
    const { organizations } = action.payload;
    const _data: Record<string, any> = {};
    const _dataByOrganizationId: Record<string, any> = {};

    organizations.forEach((organization: any) => {
      _data[organization.id] = {
        ...state.data[organization.id],
        ...organization.metadata,
        ...omit(organization, ['metadata']),
      };
      _dataByOrganizationId[organization.organization_id] = organization.id;
    });
    state.data = _data;
    state.byOrganizationId = _dataByOrganizationId;
  });

  builder.addCase(t.SET_ORGANIZATION_CONGRATS, (state, action: any) => {
    const { tenantId, congrats } = action.payload;

    state.data[tenantId] = {
      ...(state.data[tenantId] || {}),
      is_congrats: !!congrats,
    };
  });
});

export default reducer;
